import React, { Component } from 'react';
import axios from 'axios';
import {QRCodeCanvas} from 'qrcode.react';
import {
  NavLink,
  Redirect
} from 'react-router-dom';


class Home extends Component {


  constructor(props) {
    super(props);
    this.state = {
      title: '',
      body: '',
      eligardsunumname: '',
      hippurinsunumname: '',
      success: '',
      error: '',
      getuuid: '',
      keyword: '',
      tumsiralama: [],
      ilkucsiralama: [],
      count: 180
    };

    this.handleChange = this.handleChange.bind(this);
    this.updateSearchKeyword = this.updateSearchKeyword.bind(this);
    this.updateSelectedArticle = this.updateSelectedArticle.bind(this);

  }
  updateSearchKeyword(event) {
    this.setState({
      'keyword': event.target.value
    })
  }

  updateSelectedArticle(event) {
    this.fetchArticle(event.target.getAttribute('data-value'));
    const id = event.target.id;
    console.log(id);
  }


  fetchArticle(uid) {
  	var loginuid = localStorage.getItem('uid');
  	console.log(loginuid);
  
  
    var id;
    if (uid !== undefined) {
      id = uid;
    }
    else if (this.props.match.params.id !== undefined) {
      id = this.props.match.params.id;
    }
    else {
      id = loginuid;
    }
    var self = this;
    this.serverRequest = axios.get('https://api.epibiotland.com/node/' + id + '?_format=json')
    .then(function(result){
      var body = result.data.body["0"].value;
      self.setState({
        article_title: result.data.body["0"].value,
        kullanici_field_siralama: result.data.field_siralama["0"].value,
      });
    })
  }





  handleChange(event) {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value
    })
  }


  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span className="">
          <NavLink className="d-none me-2 small link-dark text-decoration-none" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="small link-light text-decoration-none" to="/user/logout">
            Çıkış Yap
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }


  componentDidMount() {


    this.fetchArticle();

    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
    var auth2 = "aGFzYW46SCo4NzM3MzIzKm4=";
  
  	console.log(auth);
  	console.log(auth2);
  
    var self = this;
    this.serverRequest = axios.get('https://api.epibiotland.com/user/' + uid + '?_format=json', {
      headers: {"Authorization":"Basic " + auth2}
    })
    .then(function(result){
      var userDate = new Date(parseInt(result.data.created["0"].value, 10)*1000);
      self.setState({
        'name': result.data.name["0"].value,
        'user_picture': result.data.user_picture["0"].url,
        'date': userDate.toISOString()
      });
    })

    var options = {  
      headers: {"Authorization":"Basic " + auth2}
    }
  
    var VariablesAPI = 'https://api.epibiotland.com/kullanicilar/';
    fetch(VariablesAPI, options)
    .then(response => response.json())
    .then(data => this.setState({ tumsiralama: data }));

    var VariablesilkucAPI = 'https://api.epibiotland.com/ilk-uc-kullanicilar/';
    fetch(VariablesilkucAPI, options)
    .then(response => response.json())
    .then(data => this.setState({ ilkucsiralama: data }));

  

  
  }





  render(){
	const { tumsiralama } = this.state;
	const { ilkucsiralama } = this.state;
    var loggedIn = localStorage.getItem('auth');
    

    var rows = [];
    var self = this;
    this.state.tumsiralama.forEach(function(tum, index) {
      if (tum.name.toLocaleLowerCase('TR').indexOf(self.state.keyword.toLocaleLowerCase('TR')) !== -1) {
        var path = tum.uid;
        rows.push(<div className="row g-0 align-items-center mb-2" key={tum.uid} key={tum.name} id={path}><div className="col-md-3 z-1"><img className="tik-pointer profile-image img-fluid rounded-circle"  data-value={tum.uid} onClick={self.updateSelectedArticle} src={`https://api.epibiotland.com${tum.user_picture}`} /></div><div className="col-md-9 ms-md-n3 bg-white rounded-end-4"><div className="tik-pointer rounded-end-4 bg-white ms-3 py-2" data-value={tum.uid} onClick={self.updateSelectedArticle} id={`kullanici-${tum.uid}`}>{tum.name}</div></div></div>);
      }
    });


    if (loggedIn) {
    
        return (


          <div className="row pt-5 position-relative">
              <div className="profile-block col-sm-3 mb-4 mb-lg-0">
                  <div className="mx-5"><img className="profile-image img-fluid rounded-circle mb-3" src={`${this.state.user_picture}`} /></div>
                  <div className="profile-username mb-2 d-flex justify-content-center p-2 rounded-3">
                      <NavLink className="text-decoration-none text-white" to="/user/profile">{this.renderUserName()}</NavLink>
                  </div>
                  <div className="text-center mb-5">{this.renderUserLinks()}</div>
                  <div className="guncelsiralama border border-white rounded-4">
                      <div className="guncelsiralama-title text-white text-center rounded-4 rounded-bottom-0 fs-5 py-2 fw-bold mb-2">Güncel Sıralama</div>
                      <div className="ilkucsiralama-liste mx-4 mb-4">
                          {ilkucsiralama.map(ilkuc =>
                          <div className="row g-0 align-items-center mb-2" key={ilkuc.name}>
                              <div className="col-md-3 z-1"><img className="tik-pointer profile-image img-fluid rounded-circle" data-value={ilkuc.uid} onClick={self.updateSelectedArticle} src={`https://api.epibiotland.com${ilkuc.user_picture}`} /></div>
                              <div className="col-md-9 ms-md-n3 bg-white rounded-end-4">
                                  <div className="tik-pointer ms-3 bg-white rounded-end-4 py-2" data-value={ilkuc.uid} onClick={self.updateSelectedArticle} id={`kullanici-${ilkuc.uid}`}>{ilkuc.name}</div>
                              </div>
                          </div>
                          )}
                      </div>
                      <form className="tumsiralama-arama mx-4 mb-4">
                          <div className="form-group">
                              <input name="keyword" value={this.state.keyword} onChange={this.updateSearchKeyword} type="text" className="form-control arama" placeholder="Kullanici Arama" />
                          </div>
                      </form>
                      <div className="tumsiralama-liste mx-4 mb-4">
                          {rows}
                      </div>
                  </div>
              </div>
              <div className="col-sm-9 position-relative">
                  <img src="/images/sayisiz-harita.svg" />
                  <div className="position-absolute top-0 start-0 w-100 z-3">


                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1085 910">
                                <g id="sayılar">
                                    <g>
                                        <circle id="_x30_2_00000077316422649464791600000001706605761188670641_" className="st0" cx="145.5" cy="200.2" r="66"/>
                                        <circle id="_x30_1" className="st1" cx="80.6" cy="298.2" r="40"/>
                                        <circle id="_x30_2" className="st0" cx="109.2" cy="386.5" r="40"/>
                                        <circle id="_x30_3" className="st0" cx="182.3" cy="441.1" r="40"/>
                                        <circle id="_x30_4" className="st2" cx="277.6" cy="460.3" r="40"/>
                                        <path id="_x30_5" className="st0" d="M414.6,454c0-22.1-17.9-40-40-40c-21.2,0-38.5,16.5-39.9,37.3v5.4c1.4,20.8,18.7,37.3,39.9,37.3
                                            C396.7,494,414.6,476.1,414.6,454z"/>
                                        <circle id="_x30_6" className="st0" cx="444.2" cy="386.5" r="40"/>
                                        <path id="_x30_7" className="st0" d="M525.5,297.9c0-22.1-17.9-40-40-40c-21.2,0-38.5,16.5-39.9,37.3v5.4
                                            c1.4,20.8,18.7,37.3,39.9,37.3C507.6,337.9,525.5,320,525.5,297.9z"/>
                                        <circle id="_x30_8" className="st2" cx="575.6" cy="269.9" r="40"/>
                                        <path id="_x30_9" className="st0" d="M627.2,262.9v5.4c1.4,20.8,18.7,37.3,39.9,37.3c22.1,0,40-17.9,40-40c0-21.2-16.5-38.5-37.3-39.9
                                            h-5.4C644.5,227,628.5,243,627.2,262.9z"/>
                                        <path id="_x31_0" className="st1" d="M801,264.9c-0.2-15.5-9.5-30.1-24.7-36.4c-4.7-2-9.6-2.9-14.4-3h-1.8c-15.4,0.4-29.8,9.6-36,24.7
                                            c-2,4.9-3,9.9-3,14.9v1c0.3,15.5,9.5,30,24.7,36.3c5.1,2.1,10.4,3.1,15.6,3.1l0,0c15.6-0.1,30.3-9.4,36.7-24.7c2-4.9,3-10,3-15
                                            L801,264.9L801,264.9z"/>
                                        <circle id="_x31_1" className="st0" cx="835.6" cy="320.1" r="40"/>
                                        <circle id="_x31_2" className="st0" cx="891.3" cy="397.9" r="40"/>
                                        <path id="_x31_3" className="st0" d="M854.3,441.1h-5.4c-20.8,1.4-37.3,18.7-37.3,39.9c0,22.1,17.9,40,40,40s40-17.9,40-40
                                            C891.6,459.8,875.1,442.5,854.3,441.1z"/>
                                        <circle id="_x31_4" className="st2" cx="758" cy="515.6" r="40"/>
                                        <path id="_x31_5" className="st0" d="M707.1,527.6c0-22.1-17.9-40-40-40c-21.2,0-38.5,16.5-39.9,37.3v5.4
                                            c1.4,20.8,18.7,37.3,39.9,37.3C689.2,567.6,707.1,549.7,707.1,527.6z"/>
                                        <circle id="_x31_6" className="st0" cx="567.5" cy="527.6" r="40"/>
                                        <path id="_x31_7" className="st3" d="M489.7,509c-20.4-8.5-43.8,1.2-52.3,21.6c-1.8,4.4-2.8,9-3,13.6v3.2c0.6,15.1,9.8,29.3,24.7,35.5
                                            c4.4,1.8,9,2.8,13.6,3h3.2c15.2-0.6,29.3-9.7,35.5-24.7C519.8,540.8,510.1,517.4,489.7,509z"/>
                                        <path id="_x31_8" className="st0" d="M440.4,602.5c0-22.1-17.9-40-40-40c-21.2,0-38.5,16.5-39.9,37.3v5.4
                                            c1.4,20.8,18.7,37.3,39.9,37.3C422.5,642.5,440.4,624.6,440.4,602.5z"/>
                                        <path id="_x31_9" className="st1" d="M434.4,694.4c-0.6-15.1-9.8-29.1-24.7-35.3c-4.6-1.9-9.3-2.9-14-3h-2.5
                                            c-15.3,0.4-29.6,9.6-35.8,24.7c-8.5,20.4,1.2,43.8,21.6,52.3s43.8-1.2,52.3-21.6c1.8-4.4,2.8-9,3-13.5v-3.6H434.4z"/>

                                            <ellipse id="_x32_0" transform="matrix(0.1602 -0.9871 0.9871 0.1602 -329.0206 1095.6827)" className="st0" cx="479.4" cy="741.2" rx="40" ry="40"/>
                                        <circle id="_x32_1" className="st0" cx="577.5" cy="749.7" r="40"/>
                                        <circle id="_x32_2" className="st0" cx="668.8" cy="724" r="40"/>
                                        <path id="_x32_3" className="st3" d="M721,687.3c-1.9,4.5-2.8,9.1-3,13.7v2.9c0.5,15.2,9.7,29.5,24.7,35.7
                                            c20.4,8.5,43.8-1.2,52.3-21.6s-1.2-43.8-21.6-52.3c-4.2-1.7-8.5-2.7-12.8-3h-5C740.7,663.7,727.1,672.8,721,687.3z"/>
                                        <path id="_x32_4_00000011026736178823829820000014950917599268003255_" className="st0" d="M813.9,661c-3.1,7.3-4.5,14.8-4.9,22.2v4.7
                                            c0.8,24.7,15.7,47.9,40.1,58c33.1,13.8,71.1-1.9,84.9-35.1c13.8-33.1-1.9-71.1-35.1-84.9c-6.8-2.8-13.8-4.4-20.8-4.9H870
                                            C845.9,622.7,823.8,637.5,813.9,661z"/>
                                        <path id="_x32_4" className="st4" d="M813.9,661c-3.1,7.3-4.5,14.8-4.9,22.2v4.7c0.8,24.7,15.7,47.9,40.1,58
                                            c33.1,13.8,71.1-1.9,84.9-35.1c13.8-33.1-1.9-71.1-35.1-84.9c-6.8-2.8-13.8-4.4-20.8-4.9H870C845.9,622.7,823.8,637.5,813.9,661z"
                                            />
                                        <g id="object_00000093174118141167562150000003548385694034211217_">
                                            <path className="st5" d="M915.1,668.8l-31.8,13.3c0,0-0.2-24.1,14.8-27.3C914.9,651.3,915.1,668.8,915.1,668.8z"/>
                                            <polygon className="st5" points="883.5,681.9 883.5,728.2 915.1,713.5 915.1,668.6 			"/>
                                            <polygon className="st1" points="883.5,727 915.1,712.2 915.1,707.1 883.5,721.7 			"/>
                                            <polygon className="st1" points="914.1,669.1 910.9,670.4 910.9,715.4 914.1,713.9 			"/>
                                            <polygon className="st3" points="915.1,668.6 911.9,670 911.9,714.9 915.1,713.5 			"/>
                                            <polygon className="st6" points="883.5,681.9 883.5,728.2 887.5,726.4 887.5,680.2 			"/>
                                            <polygon className="st7" points="832.8,668.6 832.8,709 883.5,728.2 883.5,681.9 			"/>
                                            <path className="st7" d="M902.7,654.3l-41.1-7c-3.9-0.7-9.5-1.6-13.8-0.4c-10.6,3-13.8,14.5-14.9,21.9l50.6,13.3
                                                c0,0-0.2-24.1,14.8-27.3C898.5,654.7,902.7,654.3,902.7,654.3z"/>
                                            <path className="st8" d="M852.9,654c-3.8,2.8-3.7,8.1,4.1,10.4c5,1.5,26.4,5.3,26.4,5.3l10-14.8l-25.8-4
                                                C867.7,650.8,857.8,650.4,852.9,654z"/>
                                            <path className="st1" d="M852.3,678.1v7.2c0,1.2,0.8,2.3,1.9,2.6l3.2,1c1.8,0.6,3.6-0.8,3.6-2.6v-5.7L852.3,678.1z"/>
                                            <polygon className="st1" points="833.7,669 833.7,669 833.7,709.3 837.6,710.8 837.6,670 			"/>
                                            <polygon className="st3" points="883.5,681.9 883.5,728.2 887.5,726.4 887.5,680.2 			"/>
                                            <path className="st3" d="M898.1,654.8c-14.9,3.2-14.8,27.5-14.8,27.5l31.8-13.5v-0.2C915.1,666.8,913.9,651.5,898.1,654.8z
                                                 M898.8,657.5c12.9-2.8,13.1,10.1,13.1,10.1l-24.5,10.2C887.5,677.8,887.3,660,898.8,657.5z"/>
                                            <path className="st1" d="M898.8,657.5c-11.5,2.5-11.4,20.3-11.4,20.3l24.5-10.2C911.9,667.6,911.7,654.7,898.8,657.5z M898.9,658.2
                                                c11-2.4,12,9,12,9l-22.6,9.5C888.2,676.7,889,660.4,898.9,658.2z"/>
                                            <path className="st1" d="M883.5,677.6v3.9L833.9,668c0,0,0.3-3.2,0.4-3.7L883.5,677.6z"/>
                                            <polygon className="st1" points="832.8,703.3 832.8,707.9 883.5,727.2 883.5,721.9 			"/>
                                            <polygon className="st9" points="883.5,681.9 880,681 880,726.9 883.5,728.2 			"/>
                                            <polygon className="st9" points="832.8,668.6 832.8,672.9 883.5,687.4 883.5,681.7 			"/>
                                            <polygon className="st9" points="832.8,704.3 832.8,709 883.5,728.2 883.5,723 			"/>
                                            <path className="st1" d="M851.6,648.1c1.9-0.7,6.6-1,8.2-1c-3.5-0.5-8-0.6-11.4,0.3c-10.6,3-13.8,14.1-15,21.5l3.7,0.9
                                                C837.7,665.4,839.7,652.2,851.6,648.1z"/>
                                            <polygon className="st9" points="832.8,668.6 832.8,668.7 832.8,709 836.7,710.5 836.7,669.7 			"/>
                                            <path className="st1" d="M883.5,682l-0.1,1.3l-0.9-0.3l-49.8-13.4c0,0-0.1-0.5,0-0.9L883.5,682z"/>
                                            <path className="st9" d="M897.9,653.5c-1.8,0.2-15.4-0.3-17.6,23.9L836.8,666c1.2-5.8,4.6-15,14.1-18.3c1.9-0.7,6.3-0.8,7.8-0.8
                                                c-3.5-0.5-7.6-0.8-11,0.1c-9,2.5-12.6,11.1-14.2,18.2l-0.7,3.6l50.7,13.3c1.9-29.3,18.2-27.7,20.9-27.6L897.9,653.5z"/>
                                            <polygon className="st1" points="883.5,682.2 883.5,683.3 915.1,669.9 915.1,668.8 			"/>
                                            <polygon className="st3" points="883.5,683.3 915.1,669.9 915.1,673.7 883.5,687.4 			"/>
                                            <polygon className="st3" points="883.5,728.2 915.1,713.5 915.1,708.3 883.5,723 			"/>
                                            <path className="st9" d="M851.2,678.1v7.2c0,1.2,0.8,2.3,1.9,2.6l3.2,1c1.8,0.6,3.6-0.8,3.6-2.6v-5.7L851.2,678.1z"/>
                                            <path className="st1" d="M856.5,687.1l-0.8-3.7c0.5,0,0.9-0.5,0.9-1.1c0-0.8-0.5-1.5-1.1-1.7s-1.2,0.3-1.2,1.1c0,0.6,0.3,1.2,0.7,1.5
                                                l-1.1,3L856.5,687.1z"/>
                                            <path className="st10" d="M849.2,646.6L849.2,646.6L849.2,646.6L849.2,646.6z"/>
                                            <path className="st10" d="M859.8,647L859.8,647L859.8,647z"/>
                                        
                                            <text transform="matrix(1 0 0 1 94.0696 211.2746)" className="text-st0 text-st1 text-st2">BAŞLA</text>
                                            <text transform="matrix(1 0 0 1 67.7609 304.7299)" className="text-st3 text-st1 text-st4">01</text>
                                            <text transform="matrix(1 0 0 1 94.3632 393.0296)" className="text-st0 text-st1 text-st4">02</text>
                                            <text transform="matrix(1 0 0 1 167.4559 447.6325)" className="text-st0 text-st1 text-st4">03</text>
                                            <text transform="matrix(1 0 0 1 261.6486 466.8456)" className="text-st3 text-st1 text-st4">04</text>
                                            <text transform="matrix(1 0 0 1 359.6021 460.5587)" className="text-st0 text-st1 text-st4">05</text>
                                            <text transform="matrix(1 0 0 1 428.983 393.0293)" className="text-st0 text-st1 text-st4">06</text>
                                            <text transform="matrix(1 0 0 1 471.0391 304.4708)" className="text-st0 text-st1 text-st4">07</text>
                                            <text transform="matrix(1 0 0 1 559.9966 276.4666)" className="text-st3 text-st1 text-st4">08</text>
                                            <text transform="matrix(1 0 0 1 651.9099 272.211)" className="text-st0 text-st1 text-st4">09</text>
                                            <text transform="matrix(1 0 0 1 748.1531 272.0842)" className="text-st3 text-st1 text-st4">10</text>
                                            <text transform="matrix(1 0 0 1 825.8712 326.6867)" className="text-st0 text-st1 text-st4">11</text>
                                            <text transform="matrix(1 0 0 1 879.5571 404.4477)" className="text-st0 text-st1 text-st4">12</text>
                                            <text transform="matrix(1 0 0 1 839.8418 487.61)" className="text-st0 text-st1 text-st4">13</text>
                                            <text transform="matrix(1 0 0 1 745.1191 522.1849)" className="text-st3 text-st1 text-st4">14</text>
                                            <text transform="matrix(1 0 0 1 655.1882 534.1383)" className="text-st0 text-st1 text-st4">15</text>
                                            <text transform="matrix(1 0 0 1 555.3683 534.1383)" className="text-st0 text-st1 text-st4">16</text>
                                            <text transform="matrix(1 0 0 1 462.9293 552.4435)" className="text-st3 text-st1 text-st4">17</text>
                                            <text transform="matrix(1 0 0 1 387.9586 609.0902)" className="text-st0 text-st1 text-st4">18</text>
                                            <text transform="matrix(1 0 0 1 382.2629 702.649)" className="text-st3 text-st1 text-st4">19</text>
                                            <text transform="matrix(1 0 0 1 464.5322 747.7517)" className="text-st0 text-st1 text-st4">20</text>
                                            <text transform="matrix(1 0 0 1 565.7557 756.262)" className="text-st0 text-st1 text-st4">21</text>
                                            <text transform="matrix(1 0 0 1 655.0309 730.5907)" className="text-st0 text-st1 text-st4">22</text>
                                            <text transform="matrix(1 0 0 1 744.2341 709.2185)" className="text-st3 text-st1 text-st4">23</text>

			                              	<image id="kullanici-2 adim_2" width="220" height="220" href={`${this.state.article_title}`} className="st1" transform={`${this.state.kullanici_field_siralama}`}></image>


                                        </g>
                                    </g>
                                
                                
                                
                                                <g>
                                                    <path class="epibiotland-st3" d="M217.4,878.9H59.9c-11.2,0-20.2-9-20.2-20.2v-40.4c0-11.2,9-20.2,20.2-20.2h157.4c11.2,0,20.2,9,20.2,20.2
                                                        v40.4C237.6,869.8,228.5,878.9,217.4,878.9z"/>
                                                    <text transform="matrix(1 0 0 1 54.3632 847.7732)"><tspan x="0" y="0" class="epibiotland-st5 epibiotland-st6 epibiotland-st7">EPİBİOT</tspan><tspan x="101.7" y="0" class="epibiotland-st8 epibiotland-st6 epibiotland-st7">LAND</tspan></text>
                                                </g>
                                
                                
                                
                                </g>
                        </svg>

						 

				</div>
              
              
				<div class="cube-code bottom-0 end-0 translate-middle-y d-inline-flex"><p class="p-0 small text-center rotated">TUR2315923</p></div>
              
              
              </div>
          </div>




        );
    } else {
        return (



          <div className="row top-buffer">
            <Redirect to="/user/login" />
          </div>



        );
    }
  }
}

export default Home



// WEBPACK FOOTER //
// src/components/home.jsx